import { Logger, downloadLogs } from '../../packages/logger/src/Logger';
import { INTERNAL_OPERATIONS } from "../../packages/widgets/src/utils/MetricUtils";
import { getCrossLaunchToken, msCrossLaunchToken, voiceMailEnabled, webexEmailCrossLaunchEnabled } from "./MsTeamsAuthenticationService";
import { getSelectedLineIndexForCrossLaunch, getSelectedLineGuidForCrossLaunch } from '../../components/LineSelector/utils/selectedLineStore';

/**
 *
 * @param address phone number or email address to call
 * @param isAudio
 */
export async function makeCrossLaunchCall(address: string, isAudio = false) {
  if(address) {
    if(address.toLowerCase() === INTERNAL_OPERATIONS.SAVE.toLowerCase()) {
      downloadLogs();
    }
    else {
      //  # is encoded has %23 and will be decoded back to # once call connection establishes
        address = address.replace(/^:/, "").replace(/ /g, "").replace(/#/g, "%23");
        const url = `webextel://${address}`;
        const webexcrossLaunchCallToken = await getCrossLaunchToken();
        const mscrossLaunchToken = await msCrossLaunchToken();
        const isVoiceMailEnabled = await voiceMailEnabled();
        const isWebexEmailCrossLaunchEnabled = await webexEmailCrossLaunchEnabled();
        const callUrl = new URL(url);
        const selectedToken =
          isWebexEmailCrossLaunchEnabled === "true" && isVoiceMailEnabled === "true"
            ? webexcrossLaunchCallToken || mscrossLaunchToken
            : mscrossLaunchToken;
        if (selectedToken) {
          callUrl.searchParams.append('jws', selectedToken);
        }
        callUrl.searchParams.append('isAudio', String(isAudio));
        // Preserve the desktop protocol-handler line selection contract. The
        // selected-line store is populated only after an explicit user choice,
        // so omitting these values keeps the desktop default-line behavior.
        const lineIndex = getSelectedLineIndexForCrossLaunch();
        if (lineIndex !== null) {
          callUrl.searchParams.append('lineIndex', String(lineIndex));
          const lineGuid = getSelectedLineGuidForCrossLaunch();
          if (lineGuid) {
            callUrl.searchParams.append('lineId', lineGuid);
          }
        }
        Logger.info(`[CrossLaunch] Dispatching ${isAudio ? 'audio' : 'video'} call`);
        window.open(callUrl.href);
        }
  }
}
